import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import {
  BhajanDetail,
  BhaktDetailsBySMK,
  BhaktDetailsReposonse,
  CommonAPIResponseLogin,
  EventDetails,
  FamilyDetail,
  IsPhoneNumberPresentResponse,
} from '../classes/ApiModels';
import { NewRegistrationForm } from '../classes/NewRegistrationForm';
import { BhaktType, countryCodes, EventId } from '../classes/parameters.model';
import { ToastrService } from 'ngx-toastr';
import { BhaktTokenInfo, pastPaymet, Question, Response } from '../from';
import { DatePipe, Location } from '@angular/common';
import * as Graphemer from 'graphemer';
import { FormType, FormTypeList } from '../classes/Enums';
import { CommonAPIResponse } from '../mycomponents/bhajanyag/ApiModels';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';
import { GenericContentDialogComponent } from '../mycomponents/generic-content-dialog/generic-content-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  public isSmkHolder: 'Yes' | 'No' = null;
  public bhaktType: BhaktType = null;
  public isLoading: boolean = false;
  public phoneNumberToDiaply: string = null;
  public BhaktTokenInfo: BhaktTokenInfo = {
    BhaktId: 0,
    SMKId: '',
    MobileNo: '',
    BhaktGUID: '',
    CCode: '',
    FullNameEng: '',
  };
  // public bhaktId: number = 1005;
  public eventDetails: EventDetails = {
    IsRegistrationActive: true,
    IsRegistrationActiveForSwaichikBhajan: true,
    EventId: 0,
    EventNameGuj: '',
    EventNameEng: '',
    EventStartDate: undefined,
    EventEndDate: undefined,
    EventRegistrationEndDate: undefined
  };
  public lastResponseNumber: number = 0;
  public isLandingPage: boolean = false;
  public bhaktListsToSelect: {
    BhaktId: number;
    BhaktType: BhaktType;
    Name: string;
  }[] = <{ BhaktId: number; BhaktType: BhaktType; Name: string }[]>[];
  public countryCodes = countryCodes;
  public bhaktList: FamilyDetail[] = <FamilyDetail[]>[];
  maxDate = new Date();
  // get the year, month, and day
  year = this.maxDate.getFullYear();
  month = ('0' + (this.maxDate.getMonth() + 1)).slice(-2); // add leading zero to month
  day = ('0' + this.maxDate.getDate()).slice(-2); // add leading zero to day

  // concatenate the values into a single string in yyyy-mm-dd format
  maxdateString = `${this.year}-${this.month}-${this.day}`;
  isSpotBhakt = false;
  isNRI = false;
  device: string;
  graphemer = new Graphemer.default();
  formTypeList = ['Generic', 'Rasoi', 'Chandan Vagha', 'Dhotiya', 'Generic Restricted Entry']
  deptIdForForm: number
  constructor(private http: HttpClient, private toastr: ToastrService, private datepipe: DatePipe, private location: Location, private sanitizer: DomSanitizer, private dialog: MatDialog) {

  }

  /** Same-tab or new-tab navigation without leaving an element in the template. */
  public openUrlWithAnchorClick(
    url: string,
    target: '_self' | '_blank' = '_self'
  ): void {
    const link = document.createElement('a');
    link.href = url;
    link.target = target;
    if (target === '_blank') {
      link.rel = 'noopener noreferrer';
    }
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  public downloadFormResponsePdf(responseId: number): void {
    const renderToken = sessionStorage.getItem('formToken') ?? '';
    const url = `${environment.apiUrl}/PreRegistration/GetPavti?responseId=${responseId}&render_token=${renderToken}`;
    this.openUrlWithAnchorClick(url, '_self');
  }

  public getBhaktDetailsBySMKId(
    smkId: string,
    initialLetters: string,
    birthYear
  ): Observable<BhaktDetailsBySMK[]> {
    return this.http
      .get<CommonAPIResponseLogin<BhaktDetailsBySMK[]>>(
        `${environment.apiUrlLogin}/GetBhaktPhoneNo/${smkId}/${initialLetters || 'XX'
        }/${birthYear || 0}`
      )
      .pipe(map(this.handleCommonResponse));
  }

  public getBhaktIdBasedOnPhoneNo(
    phoneNumber: string,
    bhaktType: BhaktType
  ): Observable<{ BhaktId: number; BhaktType: BhaktType; Name: string }[]> {
    return this.http
      .get<
        CommonAPIResponseLogin<
          { BhaktId: number; BhaktType: string; Name: string }[]
        >
      >(
        `${environment.apiUrlLogin}/GetBhaktBasedOnPhoneNo/${EventId}/${phoneNumber}/${bhaktType}`
      )
      .pipe(map(this.handleCommonResponse));
  }

  public getBhaktDetailsById(): Observable<BhaktDetailsReposonse> {
    return this.http
      .get<CommonAPIResponseLogin<BhaktDetailsReposonse>>(
        `${environment.apiUrlLogin}/GetBhaktWithFamilyDetails/${EventId}/${this.BhaktTokenInfo.BhaktId}/${this.bhaktType}`
      )
      .pipe(map(this.handleCommonResponse));
  }

  public checkIfPhoneNumberPresent(
    phoneNumber: string
  ): Observable<IsPhoneNumberPresentResponse> {
    return this.http
      .get<CommonAPIResponseLogin<IsPhoneNumberPresentResponse>>(
        `${environment.apiUrlLogin}/IsPhoneNoPresent/${EventId}/${phoneNumber}`
      )
      .pipe(map(this.handleCommonResponse));
  }

  public registerNewBhakt(
    formData: NewRegistrationForm
  ): Observable<{ BaktId: number }> {
    return this.http
      .put<CommonAPIResponseLogin<{ BaktId: number }>>(
        `${environment.apiUrlLogin}/SpotRegistration`,
        formData
      )
      .pipe(map(this.handleCommonResponse));
  }

  public handleCommonResponse(result: CommonAPIResponseLogin): any {
    return result.data;
  }

  public startLoading(): void {
    if (!this.isLoading) this.isLoading = true;
  }

  public stopLoading(): void {
    if (this.isLoading) this.isLoading = false;
  }

  public setMobileNumber(mobileNumber: string): void {
    this.phoneNumberToDiaply = mobileNumber;
  }

  public setBhaktId(bhaktId: number): void {
    this.BhaktTokenInfo.BhaktId = bhaktId;
  }

  public showSuccess(message: string, header: string) {
    this.toastr.success(message, header);
  }

  public showError(message: string, header: string) {
    this.toastr.error(message, header);
  }

  public showWarning(message: string, header: string) {
    this.toastr.warning(message, header);
  }

  /** Centered modal (same look as payment/other popups) instead of a top-right toast. */
  public showCenterMessage(message: string, title: string) {
    this.dialog.open(GenericContentDialogComponent, { data: { title, message } });
  }

  public showCenterError(message: string, title: string) {
    this.showCenterMessage(message, title);
  }

  public showCenterSuccess(message: string, title: string) {
    this.showCenterMessage(message, title);
  }

  public resetFields(): void {
    this.bhaktType = null;
    this.phoneNumberToDiaply = null;
    this.BhaktTokenInfo.BhaktId = null;
    this.lastResponseNumber = 0;
  }

  public loadBhaktDetails(showLoader = true) {
    if (showLoader) this.startLoading();
    return this.getBhaktDetailsById();
  }

  public setBhaktTokenInfo(data: any) {
    // console.log("Data =====> ", data);
    if (!data.MNo) return;
    if (data['SBGId']) this.isSpotBhakt = true;
    this.BhaktTokenInfo['BhaktId'] = data['BId'] || data['SBId'];
    this.BhaktTokenInfo['BhaktGUID'] = data['BGId'] || data['SBGId'];
    this.BhaktTokenInfo['MobileNo'] = data['MNo'];
    this.BhaktTokenInfo['SMKId'] = data['SId'];
    this.BhaktTokenInfo['BT'] = data['BT'];
    this.BhaktTokenInfo['CCode'] = data['CCode'];
    this.BhaktTokenInfo['FullNameEng'] = data['Name'];
    this.BhaktTokenInfo['PVE'] = data['PVE'];
    this.BhaktTokenInfo['PVG'] = data['PVG'];
    this.isNRI = this.isBhaktNRI(this.BhaktTokenInfo['MobileNo'])
    this.device = data['Device'];
  }

  public processToken(token: string) {
    if (!token) return null;
    let claims = this.decodeJWT(token);
    sessionStorage.setItem('formToken', token);
    if (
      claims['http://schemas.microsoft.com/ws/2008/06/identity/claims/userdata']
    ) {
      let BhaktInfo = JSON.parse(
        claims[
        'http://schemas.microsoft.com/ws/2008/06/identity/claims/userdata'
        ]
      );
      if (!Array.isArray(BhaktInfo)) {
        this.setBhaktTokenInfo(BhaktInfo);
      } else if (Array.isArray(BhaktInfo) && BhaktInfo.length == 1) {
        this.setBhaktTokenInfo(BhaktInfo[0]);
      }
      return BhaktInfo;
    }
  }


  public isBhaktNRI(phoneNumber: any) {
    return !phoneNumber?.replace(/\D/g, '')?.startsWith('+91');
  }

  public isTimeValidationCrossed(timeString: string) {
    const now = new Date();
    const indiaTimezoneOffset = 330 * 60 * 1000; // India Standard Time offset is UTC+5:30 in milliseconds
    const indiaTime =
      now.getTime() + now.getTimezoneOffset() * 60 * 1000 + indiaTimezoneOffset; // Adjusted time for India
    const [hours, minutes] = timeString.split(':').map(Number); // Parse the time string
    const givenTime = this.newDate();
    givenTime.setHours(hours);
    givenTime.setMinutes(minutes);
    return indiaTime > givenTime.getTime();
  }

  newDate(): Date {
    const now = new Date();
    const indiaTimezoneOffset = 330 * 60 * 1000; // India Standard Time offset is UTC+5:30 in milliseconds
    const indiaTime =
      now.getTime() + now.getTimezoneOffset() * 60 * 1000 + indiaTimezoneOffset; // Adjusted time for India
    return new Date(indiaTime);
  }

  getNextDay(dateString?: string): Date {
    const now = new Date();
    let indiaTime =
      now.getTime() + now.getTimezoneOffset() * 60 * 1000 + 330 * 60 * 1000; // Adjusted time for India

    if (dateString) {
      const [month, day, year] = dateString.split('/').map(Number);
      const selectedDate = new Date(year, month - 1, day); // Note: month is 0-based in JavaScript
      indiaTime = selectedDate.getTime() + 330 * 60 * 1000; // Adjusted time for India
    }

    const nextDayTime = indiaTime + 24 * 60 * 60 * 1000; // Next day in milliseconds
    return new Date(nextDayTime);
  }

  operateWithTwoDigitAccuracy(num1, num2, operator) {
    // Multiply numbers by 100 to preserve two decimal places
    let intNum1 = Math.round(num1 * 100);
    let intNum2 = Math.round(num2 * 100);

    let result = 0;

    // Perform operation based on the operator
    switch (operator) {
      case '+':
        result = (intNum1 + intNum2) / 100;
        break;
      case '-':
        result = (intNum1 - intNum2) / 100;
        break;
      case '*':
        result = (intNum1 * intNum2) / 10000; // Division by 100^2
        break;
      case '/':
        if (intNum2 !== 0) {
          result = (intNum1 / intNum2);
        } else {
          console.log("Division by zero error");
        }
        break;
      default:
        throw new Error("Invalid operator");
    }

    return result;
  }

  filterDataByColumns(data, columns) {
    return data.map(obj => {
      const filteredObject = {};
      columns.forEach(column => {
        if (obj.hasOwnProperty(column)) {
          filteredObject[column] = obj[column];
        }
      });
      return filteredObject;
    });
  }

  dateFormatter(type: string, data: any) {
    if (!data) return ''
    let format = type == 'rasoidate' ? 'dd/MM/yyyy' : 'dd/MM/yyyy HH:mm:ss'
    return this.datepipe.transform(data.value, format) || ''
  }

  dateFullFormatter(type: string, data: any) {
    if (!data) return ''
    let parsedDate = new Date(data.value)
    return parsedDate.toLocaleDateString('en-In', { day: '2-digit', month: 'long', year: 'numeric' });
  }

  paymentStatusformat(data: any) {
    let status = ""
    if (data) {
      let val = data.toLowerCase()
      switch (val) {
        case 'paymentinitiated':
          status = "Initiated";
          break;
        case 'success':
          status = "Success";
          break;
        case 'failure':
          status = "Failed";
          break;
        case 'pending':
          status = "Pending";
          break;
        case 'paylater':
          status = "Pay Later";
          break;
        default:
          status = val
      }
    }
    return status
  }


  formTypeStr(type: number) {
    let formtype = '-'
    switch (type) {
      case 1:
        formtype = FormTypeList.Generic;
        break;
      case 2:
        formtype = FormTypeList.RASOI;
        break;
      case 3:
        formtype = FormTypeList.CHANDAN;
        break;
      case 4:
        formtype = FormTypeList.DHOTIYA;
        break;
      case 5:
        formtype = FormTypeList.GenericRestrictedEntry;
        break;
      case 6:
        formtype = FormTypeList.ThalBhet;
        break;
      case 7:
        formtype = FormTypeList.BhajanYag;
        break;
      case 8:
        formtype = FormTypeList.Yagna;
        break;
      case 9:
        formtype = FormTypeList.PrasadBooking;
        break;
      default:
        formtype = FormTypeList.Generic
    }

    return formtype
  }


  sortByKeyArr(array, keyArr) {
    array.sort((a, b) => {
      // Compare each object based on the keysOrder
      for (let key of keyArr) {
        const aValue = a[key] ? a[key].toLowerCase() : ''; // Convert to lowercase for comparison
        const bValue = b[key] ? b[key].toLowerCase() : ''; // Convert to lowercase for comparison
        // Compare the values
        if (aValue < bValue) {
          return -1;
        }
        if (aValue > bValue) {
          return 1;
        }
      }
      return 0; // If all keys are equal
    });
    return array
  }

  goBack(): void {
    this.location.back();
  }

  countGujaratiCharacters(str) {
    return this.graphemer.countGraphemes(str)
  }

  stripHtml(htmlString: string) {
    // Remove HTML tags
    const stringWithoutTags = htmlString.replace(/<[^>]+>/g, '');
    // Remove HTML entities
    const stringWithoutEntities = stringWithoutTags.replace(/&([^;]+);/g, '');
    // Replace consecutive spaces with a single space
    const stringWithoutConsecutiveSpaces = stringWithoutEntities.replace(/\s+/g, ' ').trim();
    return stringWithoutConsecutiveSpaces;
  }

  /** Map PrasadVitran SearchPavti row to past-payments grid shape. */
  mapPavtiVitranRowToPastPayment(p: any): pastPaymet {
    const kundal = Number(p?.KundalAmount) || 0;
    const vadodara = Number(p?.KarelibaugAmount) || 0;
    return {
      BhaktId: p?.BhaktId ?? 0,
      BhaktGUID: '',
      NameEng: p?.LoginName || p?.PaymentAccountName || '',
      NameGuj: p?.NameForRasoi || '',
      TransactionReferenceNumber: p?.TransactionReferenceNumber ?? '',
      TransactionDate: p?.TransactionDate,
      TransactionStatus: p?.TransactionStatus,
      RasoiDate: p?.RasoiDate ?? p?.TransactionDate,
      Amount: Number(p?.TransactionAmount) || 0,
      Nimit: '',
      NimitDescription: '',
      NameForRasoi: p?.NameForRasoi ?? '',
      RasoiFor: '',
      EmailForThalbhet: '',
      PaymentAccountName: p?.PaymentAccountName ?? '',
      KundalAmount: kundal,
      VadodaraAmount: vadodara,
      KundalAmount2: 0,
      WantPrasad: p?.WantPrasad ?? '',
      FormType: FormType.RASOI,
      CountofThalbhet: 0,
      DaysforThalbhet: '',
      PrasadQuantity:
        p?.PrasadQuantity != null ? Number(p.PrasadQuantity) : undefined,
      PrasadGivenDateTime: p?.PrasadGivenDateTime,
    };
  }

  /** Keep rows whose TransactionDate falls on/after (today − months). */
  filterTransactionRowsToLastMonths<T extends { TransactionDate?: string | Date }>(
    rows: T[],
    months: number
  ): T[] {
    const cutoff = new Date();
    cutoff.setMonth(cutoff.getMonth() - months);
    cutoff.setHours(0, 0, 0, 0);
    return (rows || []).filter((r) => {
      const d = r.TransactionDate ? new Date(r.TransactionDate) : null;
      return d != null && !isNaN(d.getTime()) && d >= cutoff;
    });
  }

  mapPastObject(element: any) {
    let str = ''
    if (element['FormType'] == FormType.RASOI) {
      // if ((element['KundalAmount'] > 0 || element['KundalAmount'] > 0) && element['VadodaraAmount'] > 0) {
      //   str = 'કુંડળધામ અને વડોદરા - ઠાકોરજીને થાળ તથા રસોઈ'
      // } else if (element['KundalAmount'] > 0 || element['KundalAmount'] > 0) {
      //   str = 'કુંડળધામ - ઠાકોરજીને થાળ તથા રસોઈ'
      // } else if (element['VadodaraAmount'] > 0) {
      //   str = 'વડોદરા - ઠાકોરજીને થાળ તથા રસોઈ'
      // } else {
      //   str = '-'
      // }
      // element['RasoiFor'] = str
    } else {
      element['RasoiFor'] = this.formTypeStr(+element['FormType'])
    }
    element['TransactionStatus'] = this.paymentStatusformat(element['TransactionStatus'])


    return element
  }

  urlBase64Decode(str: string): string {
    str = str.replace(/-/g, '+').replace(/_/g, '/');
    while (str.length % 4 !== 0) {
      str += '=';
    }
    return atob(str);
  }

  decodeJWT(token: string): any {
    const payload = token.split('.')[1];
    const decodedPayload = this.urlBase64Decode(payload);
    return JSON.parse(decodedPayload);
  }

  getDepartmentIdFromToken(): number {
    const token =
      sessionStorage.getItem('formToken') || localStorage.getItem('formToken');
    if (!token) return -1;
    try {
      const claims = this.decodeJWT(token);
      const userdata = claims['http://schemas.microsoft.com/ws/2008/06/identity/claims/userdata'];
      if (userdata) {
        const userData = JSON.parse(userdata);
        return userData.DepartmentId ?? -1;
      }
      return -1;
    } catch {
      return -1;
    }
  }

  copyToClipboard(value: string): void {
    const textarea = document.createElement('textarea');
    textarea.value = value;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
  }

  removeHtmlTags(htmlString: string) {
    const div = document.createElement('div');
    div.innerHTML = htmlString;
    return div.textContent || div.innerText || '';
  }

  formToBhajayanFormat(data: any) {
    const result = [];
    const qnArr = data.FormQuestions;
    const responseArr = data.FormResponse;

    responseArr.forEach(response => {
      const BhaktId = response.BhaktId;
      const ResponseId = response.Id || 0;
      const FormId = data.Id;

      const rr: any = {
        BhaktId: BhaktId,
        ResponseId: ResponseId,
        FormId: FormId
      };

      response.ResponseDetail.forEach(detail => {
        const qn = qnArr.find(q => q.Id === detail.QuestionId);
        if (qn) {
          const cleanQnText = this.removeHtmlTags(qn.QuestionText);
          rr[cleanQnText] = detail.Response;
        }
      });

      result.push(rr);
    });

    return result;
  }

  bhajanFormatToFormResponse(result: any[], formQuestions: any[],formID:number,reponseIdMap:any) {
    const formResponses = result.map((entry, index) => {
      const responseId = entry.ResponseId || 0;
      const formId = formID;
      const bhaktId = entry.BhaktId;
      const responseTime = new Date().toISOString(); // Customize if needed

      const responseDetail = Object.entries(entry)
        .filter(([key]) => !['BhaktId', 'ResponseId', 'FormId'].includes(key))
        .map(([questionText, responseValue], detailIndex) => {
          const question = formQuestions.find(q =>
            this.removeHtmlTags(q.QuestionText).toLowerCase() === questionText.toLowerCase()
          );

          return question
            ? {
              Id: reponseIdMap[String(responseId)+String(question.Id)] || 0,
              ResponseId: responseId,
              QuestionId: question.Id,
              Response: responseValue || ''
            }
            : null;
        })
        .filter(detail => detail !== null);

      return {
        Id: responseId,
        FormId: formId,
        BhaktId: bhaktId,
        ResponseTime: responseTime,
        ResponseDetail: responseDetail
      };
    });

    return formResponses;
  }

  sanitizeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  decodeHtml(html: string): string {
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
  }

  sanitizeAndDecodeHtml(html: string): SafeHtml {
    const decodedHtml = this.decodeHtml(html);
    return this.sanitizeHtml(decodedHtml);
  }
}
